import { useState, useRef, memo } from 'react';
import classNames from 'classnames';
import Image from '@picsart/image/Image';
import View from '@picsart/view/View';

import getGridImageSizes from 'utils/images/getGridImageSizes';
import { IGridItemImageBox } from 'pages/Batch/types';

import useStyles from './useStyles';

const GridItemImageBox = ({
  imgSrc,
  boxWidth,
  boxHeight,
}: IGridItemImageBox) => {
  const [{ width: currentWidth, height: currentHeight }, setImageBoxSize] = useState({
    width: '0',
    height: '0',
  });

  const classes = useStyles({
    width: currentWidth,
    height: currentHeight,
  });

  const imageRef = useRef<HTMLImageElement>(null);

  const handleImageSize = (wrapperWidth: number, wrapperHeight: number) => {
    const imgBoxSizes = getGridImageSizes(wrapperWidth, wrapperHeight, imageRef.current as HTMLImageElement);
    setImageBoxSize(imgBoxSizes);
  };

  return (
    <View className={classNames(classes.gridImageWrap)}>
      <Image ref={imageRef} className={classes.gridImage} src={imgSrc} onLoad={() => handleImageSize(boxWidth, boxHeight)} alt="img" />
    </View>
  );
};

export default memo(GridItemImageBox);
